"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const session_1 = require("../../../../session");
const dates_and_calendars_1 = require("../dates-and-calendars");
function Definition(params) {
    return {
        getData(session = (0, session_1.getDefault)()) {
            const datesAndCalendarsProvider = new dates_and_calendars_1.DatesAndCalendarsProvider(session);
            return datesAndCalendarsProvider.getIsWorkingDay([params]);
        },
        /** @internal */
        getInstrument() {
            return (0, lodash_functions_1.cloneDeep)(params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9kYXRlcy1hbmQtY2FsZW5kYXJzL2lzLXdvcmtpbmctZGF5L2RlZmluaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsd0VBQThEO0FBQzlELGlEQUFpRDtBQUNqRCxnRUFBbUU7QUFFbkUsU0FBZ0IsVUFBVSxDQUN0QixNQUFpRDtJQUVqRCxPQUFPO1FBQ0gsT0FBTyxDQUFDLFVBQW1CLElBQUEsb0JBQVUsR0FBRTtZQUNuQyxNQUFNLHlCQUF5QixHQUFHLElBQUksK0NBQXlCLENBQUMsT0FBTyxDQUFDLENBQUM7WUFFekUsT0FBTyx5QkFBeUIsQ0FBQyxlQUFlLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO1FBQy9ELENBQUM7UUFFRCxnQkFBZ0I7UUFDaEIsYUFBYTtZQUNULE9BQU8sSUFBQSw0QkFBUyxFQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQzdCLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQWZELGdDQWVDIn0=